
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsPosScreenTypeDialog extends Serenity.EntityDialog<PsPosScreenTypeRow, any> {
        protected getFormKey() { return PsPosScreenTypeForm.formKey; }
        protected getIdProperty() { return PsPosScreenTypeRow.idProperty; }
        protected getLocalTextPrefix() { return PsPosScreenTypeRow.localTextPrefix; }
        protected getNameProperty() { return PsPosScreenTypeRow.nameProperty; }
        protected getService() { return PsPosScreenTypeService.baseUrl; }
        protected getDeletePermission() { return PsPosScreenTypeRow.deletePermission; }
        protected getInsertPermission() { return PsPosScreenTypeRow.insertPermission; }
        protected getUpdatePermission() { return PsPosScreenTypeRow.updatePermission; }

        protected form = new PsPosScreenTypeForm(this.idPrefix);

    }
}